export default "__VITE_ASSET__CMyAPGyT__"